import React from "react";
import ContentContainer from "@insightfulscience/atomic-react/r1/atoms/ContentContainer";
import { publicConfig } from "../../config";

export type ErrorDetailsProps = {
	error: object;
};

function ErrorDetails({ error }: ErrorDetailsProps) {
	return (
		<ContentContainer mx md={10} lg={8} center>
			<div className="panel bg-color-black">
				<pre className=" text-color-white px-5 py-5">
					{JSON.stringify(error, null, 2)}
				</pre>
			</div>
		</ContentContainer>
	);
}

export default publicConfig.DEBUG_MODE ? ErrorDetails : () => null;
